import Clarity from '@microsoft/clarity';

let activeProjectId: string | null = null;

const LOCAL_HOSTNAMES = new Set(['localhost', '127.0.0.1', '0.0.0.0', '::1']);

const isLocalHostname = (hostname: string) =>
  LOCAL_HOSTNAMES.has(hostname) || hostname.endsWith('.localhost');

export const initMicrosoftClarity = (projectId: string) => {
  if (typeof window === 'undefined') return;
  if (isLocalHostname(window.location.hostname)) return;
  if (!projectId || activeProjectId === projectId) return;

  activeProjectId = projectId;
  Clarity.init(projectId);
};
